'use strict';

import Toast from 'bootstrap/js/src/toast';

export default class VZToast extends HTMLElement {
    constructor(toastID, options) {
        super();

        this.toastID = toastID;
        this.options = options || {
            animation: true,
            autohide: true,
            delay: 3000
        };

        this.toastAnchor = document.querySelector('.js-toast-anchor');
        this.setPosition = this.setPosition.bind(this);

        // Don't create another one if one already exists with the given ID
        if (!document.getElementById(this.toastID)) {
            const toastContainer = document.querySelector('.js-toast-container');
            toastContainer.appendChild(this);
        }
    }

    setBodyMessage(message) {
        const toastBody = this.querySelector('.js-toast-body');
        if (toastBody) toastBody.textContent = message;
    }

    connectedCallback() {
        this.innerHTML = `
            <div class="row justify-content-center ${this.toastID}-toast">
                <div class="col-sm-8 col-md-6 col-lg-5">
                    <div class="custom-toast">
                        <div class="toast p-2" id="${this.toastID}">
                            <div class="toast-body js-toast-body py-0 px-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        const toastElement = document.getElementById(this.toastID);

        if (toastElement) {
            this.setPosition();

            this.toast = new Toast(toastElement, this.options);

            toastElement.addEventListener('hidden.bs.toast', () => {
                this.remove();
            });

            window.addEventListener('scroll', this.setPosition);
            window.addEventListener('resize', this.setPosition);
        }
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.setPosition);
        window.removeEventListener('resize', this.setPosition);
    }

    setPosition() {
        const toast = this.querySelector('.custom-toast');
        const yPosition = this.toastAnchor.getBoundingClientRect().y;
        const footerIsVisible = yPosition - window.innerHeight < 0;
        const baseBottom = 20;

        if (footerIsVisible) {
            toast.style.bottom = `${Math.abs(yPosition - window.innerHeight - baseBottom)}px`;
        } else {
            toast.style.bottom = `${baseBottom}px`;
        }
    }

    show() {
        this.toast.show();
    }
}

if (!window.customElements.get('vz-toast')) {
    window.customElements.define('vz-toast', VZToast);
}
